<template>
  <div>

    <approval-remarks :row-data="actionData" :steps="actionData.steps" :legal-step="3" />

    <div v-if="legalApproved">
    <section v-if="isTowerCo()">
      <el-row>

        <el-form label-position="top" :inline="isBackhaul">

          <!-- TODO fill in contractors -->

          <el-col :span="7" v-if="false">
            <el-form-item> <!-- TODO fix step.state.contractorW to PTW -->
              <el-select v-model="step.state.contractorW"
              :disabled="disabled" />
            </el-form-item>
          </el-col>

          <el-col :span="7" :offset="1" v-if="false">
            <el-form-item>
              <el-select v-model="step.state.contractorTI"
              :disabled="disabled" />
            </el-form-item>
          </el-col>

          <el-col :span="7" :offset="1" v-if="false">
            <el-form-item>
              <el-select v-model="step.state.contractorMW"
              :disabled="disabled" />
            </el-form-item>
          </el-col>


        <section v-if="isBackhaul">
          <h4>Permit to Work</h4><br />
            <check-box v-model="step.state.approvalPTW" :disabled="disabled">{{step.state.approvalPTW ? 'Approved' : 'Pending / Rejected'}}</check-box>

            <date-input  v-if="step.state.approvalPTW" v-model="step.state.approvedPTW"
            :disabled="!step.state.approvalPTW || disabled" />

            <check-box  v-if="step.state.approvalPTW" v-model="step.state.depostiReturnedPTW" :disabled="!step.state.approvalPTW || disabled">Deposit Returned</check-box>

      </section>



      <section v-else>
        <el-row>

          <el-col :span="8">
            <h4>CME</h4>
            <check-box v-model="step.state.approvalCME" :disabled="disabled">{{step.state.approvalCME ? 'Approved' : 'Pending / Rejected'}}</check-box>
            <date-input v-if="step.state.approvalCME" v-model="step.state.approvedCME"
              :disabled="!step.state.approvalCME || disabled" />

            <check-box v-if="step.state.approvalCME" v-model="step.state.depostiReturnedCME" :disabled="!step.state.approvalCME || disabled">Deposit Returned</check-box>
          </el-col>

          <el-col :span="8">
            <h4>TI</h4>
              <check-box v-model="step.state.approvalTI" :disabled="disabled">{{step.state.approvalTI ? 'Approved' : 'Pending / Rejected'}}</check-box>

              <date-input v-if="step.state.approvalTI" v-model="step.state.approvedTI"
              :format="dateFormat"
              :disabled="!step.state.approvalTI || disabled" />

            <check-box v-if="step.state.approvalTI" v-model="step.state.depostiReturnedTI" :disabled="!step.state.approvalTI || disabled">Deposit Returned</check-box>

          </el-col>

          <el-col :span="8">
            <h4>MW</h4>
              <check-box v-model="step.state.approvalMW" :disabled="disabled">{{step.state.approvalMW ? 'Approved' : 'Pending / Rejected'}}</check-box>
              <date-input v-if="step.state.approvalMW" v-model="step.state.approvedMW"
              :disabled="!step.state.approvalMW || disabled" />

              <check-box v-if="step.state.approvalMW" v-model="step.state.depostiReturnedMW" :disabled="!step.state.approvalMW || disabled">Deposit Returned</check-box>
          </el-col>
        </el-row>
      </section>

    </el-form>

      <el-col :span="22" :class="disabled ? '' : 'bg-lighter'" :style="disabled ? '' : 'padding-left: 1em; padding-top: 1em; border-radius: 1em;'">

          <el-form :inline="true">

            <check-box v-model="step.state.depositRequired" :disabled="disabled">Overall Deposit Required</check-box>

            <el-form-item label="Paid" v-if="step.state.depositRequired">
              <el-switch active-text="Yes" inactive-text="No" v-model="step.state.paid" :disabled="disabled" />
            </el-form-item>

            <el-form-item label="Amount" v-if="step.state.depositRequired">
              <el-input type="number" v-model="step.state.deposit"
              :disabled="!step.state.paid || disabled">
              <template #prepend>{{currencyLabel}}</template>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>

      </el-row>
  </section>

  <el-alert
  v-if="this.isActive(this.actionData)"
  type="info"
  title="Progress Remarks"
  show-icon />

  <!-- XOL-526 (S5, D9): was `disabled` (canWriteStep()-gated) — a counterparty
       may now write its own party-2 row (canWriteOwnStep()), which also
       folds in the party-1-step-completed lock (D9/A10). Tower Co unchanged
       (canWriteOwnStep() is canWriteStep() for a Tower Co viewer). -->
  <small v-if="progressRemarksNote" class="text-muted">{{progressRemarksNote}}</small>
  <html-input v-model="step.remarks" :disabled="!canWriteOwnStep(step) || readOnly" />
  <small v-if="progressRemarksStamp" class="text-muted">{{lastUpdatedLine(progressRemarksStamp)}}</small>

  </div>

</div>

</template>



<script>

import {settings} from '@/components/Data'

import RequestMixins from '@/mixins/RequestMixins'

import FileDownload from '@/components/atoms/files/FileDownload'
import FileUpload from '@/components/atoms/files/FileUpload'

import ApprovalRemarks from '@/components/requests/workflow/ApprovalRemarks'


export default {

  // XOL-534 (reviewer): DateMixins already arrives transitively via
  // RequestMixins -> SiteMixins — a direct import here was redundant.
  mixins: [RequestMixins],

  components: {
    ApprovalRemarks,
    FileDownload,
    FileUpload
  },



  props: {

    rowData: {
      type: Object,
      required: true
    },

    rowIndex: {
      type: Number,
      default: null
    },

    stepData: {
      type: Object,
      default: null
    },

    readOnly: {
      type: Boolean,
      default: true
    },

    isClosed: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    setStep (data) {
      if (data) {
        this.step = data

        // XOL-526 (S5): re-capture the dirty baseline off the fresh fetch.
        this.initialRemarks = data.remarks
      }
    }

  },

  computed: {

    disabled () {
      return !this.canWriteStep() || this.isViewOnly() || this.readOnly
    },

    // XOL-526 (UX §2.4, U-I): Progress Remarks is the counterparty's own
    // party-2 STEP row — Tower Co's own row (party 1) is a different object
    // and is never shared, so it gets no note/stamp.
    progressRemarksStamp () {
      return (!this.isTowerCo() && this.step) ? this.editStamp(this.step.state, 'remarks') : null
    },

    progressRemarksNote () {
      return (this.canWriteOwnStep(this.step) && !this.isTowerCo() && !this.readOnly && this.hasDistinctProvider())
        ? this.sharedFieldNote('edit these remarks')
        : null
    }

  },


  data () {

    return {
      currencyLabel: settings.currency,
      dateFormat: settings.selectDateFormat,
      actionData: this.rowData,
      step: this.stepData,
      step3: this.rowData.state.step3,
      legalApproved: (this.rowData.status === 'Closed') ? true : this.rowData.state.step3.legalApproved,

      // XOL-526 (S5): dirty baseline for the counterparty's own saveOwnStep().
      initialRemarks: null
    }

  }, // data



  created () {
    // XOL-534 (reviewer R2): unconditional baseline, set BEFORE the possible
    // findStep() fetch — see step1.vue's created() for why. setStep()
    // re-captures it fresh once the fetch resolves.
    if (this.step) {
      this.initialRemarks = this.step.remarks
    }

    // XOL-526 (S5, D9): was `canWriteStep()` — a counterparty may now write
    // its own party-2 row too.
    if ((this.canWriteStep() || this.canWriteOwnStep(this.step)) && !this.readOnly && this.step) {
      this.findStep(this.stepData.id, this.setStep)
    }

  },



  beforeDestroy () {

    if (!this.readOnly && this.step) {
      this.$emit('updated', this.step)

      if (this.canWriteStep()) {
        this.saveStep(this.step, null, this.actionData)
      } else if (this.canWriteOwnStep(this.step) && this.step.remarks !== this.initialRemarks) {
        // XOL-526 (S5, D9): dirty-only, own-row remarks.
        this.saveOwnStep(this.step, {remarks: this.step.remarks})
      }
    }

  }

}
</script>
